export const DRAGGABLE_HANDLE = 'slot-item-handle';
